// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"ccf9ccf2","496":"9116a08c","509":"a97da312"}[chunkId] + ".chunk.css";
};